const colors = {
  primary000: '#F2F7F8',
  primary100: '#DCECED',
  primary200: '#BDDEE1',
  primary300: '#82C5CB',
  primary400: '#50B2C2',
  primary500: '#006D86',
  primary600: '#014558',

  secondary100: '#E2FAFC',
  secondary200: '#B2EEF3',
  secondary300: '#66D7E3',
  secondary400: '#00B3C4',
  secondary500: '#008B98',
  secondary600: '#00575F',

  neutral000: '#FBF9F4',
  neutral100: '#F5F3ED',
  neutral200: '#E5E2DC',
  neutral300: '#BCB8B1',
  neutral400: '#55697A',
  neutral500: '#304753',
  neutral600: '#1F2F3A',

  error100: '#FCE0E0',
  error200: '#FDB4B4',
  error300: '#EE8E8E',
  error400: '#DC0505',
  error500: '#990000',
  error600: '#730000',

  success100: '#DDF3ED',
  success200: '#BCEBDD',
  success300: '#80D8BD',
  success400: '#15C590',
  success500: '#007F59',
  success600: '#034C36',

  black: '#000000',
  white: '#FFFFFF',
  transparent: 'transparent',
  overlay: 'rgba(1,69,88,0.35)',
  itsmeBrand: '#FF4612',
};

export default colors;
